import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Swiper, SwiperSlide} from 'swiper/react';
import cc from 'classcat';
import {Capacitor} from '@capacitor/core';

import styles from './collectionList.module.scss';

interface Props {
  collections: CollectionListItem[];
  brandName: string;
  setShow: (is: boolean) => void;
}

export default function index({collections, brandName, setShow}: Props) {
  const navigator = useNavigate();
  const toggleSetting = () => {
    if (Capacitor.getPlatform() === 'web') {
      setShow(true);
    } else {
      //knewnnew-dev-s3.s3.amazonaws.com/brands/202312180626401b08dc3585
      // Echo.echo({
      //   value: 'setting',
      // });
      navigator('/push-config');
    }
  };

  const goTo = (id: number) => {
    navigator(`/popup/${id}`);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>COLLECTION</div>
      <p className={styles.desc}>F&B 브랜드를 색다르게 경험하는 특별한 상품</p>
      <div className={styles.collections}>
        <Swiper
          className="collectionSwiper"
          initialSlide={0}
          spaceBetween={8}
          slidesPerView={'auto'}
          centeredSlides={true}
          centeredSlidesBounds={true}
          slideToClickedSlide={true}
          // slidesOffsetBefore={20}
          slidesOffsetAfter={20}>
          {collections?.map((item, index) => (
            <SwiperSlide key={`slide-item-${index}`}>
              <div
                className={cc([
                  styles.item,
                  {[styles.before]: item.status === '2_before_open'},
                ])}>
                <div className={styles.imgWrapper}>
                  <img
                    src={
                      item.collectionImageUrl
                        ? item.collectionImageUrl
                        : item.imageUrl
                    }
                  />
                </div>
                {(item.status === '1_opened' ||
                  item.status === '1_sold_out') && (
                  <div
                    className={styles.txtWrapper}
                    onClick={() => goTo(item.id)}
                    style={{cursor: 'pointer'}}>
                    <div className={styles.title}>{item?.bannerTitle}</div>
                    <div className={styles.status}>{item.info}</div>
                    <button type="button" className={styles.btn}>
                      구매하기
                    </button>
                  </div>
                )}
                {item.status === '2_before_open' && (
                  <>
                    <div className={styles.txtWrapper}>
                      <div className={styles.title}>{item?.bannerTitle}</div>
                      <div className={styles.status}>오픈 예정</div>
                      <button type="button" className={styles.btn}>
                        COMING SOON
                      </button>
                    </div>
                  </>
                )}
                {item.status === '3_closed' && (
                  <div
                    className={styles.txtWrapper}
                    onClick={() => goTo(item.id)}
                    style={{cursor: 'pointer'}}>
                    <div className={styles.title}>{item?.bannerTitle}</div>
                    <div className={styles.status}>{item.info}</div>
                    <button
                      type="button"
                      className={styles.btn}
                      onClick={() => goTo(item.id)}>
                      자세히보기
                    </button>
                  </div>
                )}
              </div>
            </SwiperSlide>
          ))}
          <SwiperSlide key={`slide-item-${collections.length}`}>
            <div className={cc([styles.item, styles.new])}>
              <div className={styles.imgWrapper}></div>
              <div className={styles.txtWrapper}>
                <div className={styles.title}>
                  {`새로운 컬렉션이\n곧 찾아옵니다`}
                </div>
                <div className={styles.status}>
                  {`${brandName}의 새로운 컬렉션,\n놓치지 마세요.`}
                </div>
                <button
                  type="button"
                  className={styles.btn}
                  onClick={toggleSetting}>
                  <span className={`icon bell-icon ${styles.setup_bell}`}>
                    &nbsp;
                  </span>
                  <span>알림 설정</span>
                </button>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div style={{padding: '30px 20px 40px'}}>
        <button
          className={styles.collectionViewMoreBtn}
          onClick={() => navigator(`/collection/list`)}>
          <span className={styles.txt}>다른 컬렉션 보기</span>
          <span className={styles.collectionViewMoreIcon}></span>
        </button>
      </div>
    </div>
  );
}
